export default function (ctrl) {
	return function (event) {

		//IExplorerben nem működik
		if (!event.clipboardData || !event.clipboardData.items ) {
			return '';
		}

		var item = event.clipboardData && event.clipboardData.items[0];
		item.getAsString(function (data) {
			ctrl.otpLogin.invoiceNumber = data;
			ctrl.$scope.$apply();
			if (/^\d{16}$/.test(ctrl.otpLogin.invoiceNumber)) {
				ctrl.otpLogin.invoiceNumber = ctrl.otpLogin.invoiceNumber.substring(0, 8) + '-' + ctrl.otpLogin.invoiceNumber.substring(8, 16);
			} else if (/^\d{24}$/.test(ctrl.otpLogin.invoiceNumber)) {
				ctrl.otpLogin.invoiceNumber = ctrl.otpLogin.invoiceNumber.substring(0, 8) + '-' + ctrl.otpLogin.invoiceNumber.substring(8, 16) +
					'-' + ctrl.otpLogin.invoiceNumber.substring(16, 24);

			} else if (/^\d{8}-\d{16}$/.test(ctrl.otpLogin.invoiceNumber)) {
				ctrl.otpLogin.invoiceNumber = ctrl.otpLogin.invoiceNumber.substring(0, 17) + '-' + ctrl.otpLogin.invoiceNumber.substring(17, 25);
			} else if (/^\d{16}-\d{8}$/.test(ctrl.otpLogin.invoiceNumber)) {
				ctrl.otpLogin.invoiceNumber = ctrl.otpLogin.invoiceNumber.substring(0, 8) + '-' + ctrl.otpLogin.invoiceNumber.substring(8, 25);
			}
			if (!ctrl.$scope.$$phase) {
				ctrl.$scope.$apply();
			}
		});
	};
};
